import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPayments = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 29,
	height: 29,
	viewBox: "0 0 29 29",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Payments",
		children: /* @__PURE__ */ _jsxs("g", {
			id: "Vector",
			children: [
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M22.4929 24.4519C22.8346 24.7936 23.3887 24.7936 23.7304 24.4519L26.0637 22.1186C26.4054 21.7768 26.4054 21.2228 26.0637 20.8811C25.722 20.5394 25.168 20.5394 24.8263 20.8811L23.9867 21.7207V16.8332C23.9867 16.3499 23.5949 15.9582 23.1117 15.9582C22.6284 15.9582 22.2367 16.3499 22.2367 16.8332V21.7207L21.397 20.8811C21.0553 20.5394 20.5013 20.5394 20.1596 20.8811C19.8179 21.2228 19.8179 21.7768 20.1596 22.1186L22.4929 24.4519Z",
					fill: "#808080"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M12.6117 5.1665H17.2783C21.6781 5.1665 23.878 5.1665 25.2448 6.53334C26.2289 7.51747 26.5045 8.93346 26.5816 11.2915H3.30832C3.38547 8.93346 3.66102 7.51747 4.64516 6.53334C6.01199 5.1665 8.21188 5.1665 12.6117 5.1665Z",
					fill: "#808080"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M12.6117 23.8332H17.2783C18.0477 23.8332 18.7499 23.8332 19.392 23.8259L18.9222 23.356C17.897 22.3309 17.897 20.6688 18.9222 19.6437C19.3604 19.2054 19.9151 18.9545 20.4867 18.891V16.8332C20.4867 15.3834 21.6619 14.2082 23.1117 14.2082C24.5614 14.2082 25.7367 15.3834 25.7367 16.8332V18.891C25.9978 18.92 26.2554 18.9882 26.5001 19.0954C26.6117 17.9032 26.6117 16.4085 26.6117 14.4998C26.6117 13.9843 26.6117 13.4989 26.6095 13.0415H3.28052C3.27832 13.4989 3.27832 13.9843 3.27832 14.4998C3.27832 18.8996 3.27832 21.0995 4.64516 22.4663C6.01199 23.8332 8.21188 23.8332 12.6117 23.8332ZM7.94499 18.2915C7.46174 18.2915 7.06999 18.6833 7.06999 19.1665C7.06999 19.6498 7.46174 20.0415 7.94499 20.0415H12.6117C13.0949 20.0415 13.4867 19.6498 13.4867 19.1665C13.4867 18.6833 13.0949 18.2915 12.6117 18.2915H7.94499ZM15.5283 18.2915C15.0451 18.2915 14.6533 18.6833 14.6533 19.1665C14.6533 19.6498 15.0451 20.0415 15.5283 20.0415H17.2783C17.7616 20.0415 18.1533 19.6498 18.1533 19.1665C18.1533 18.6833 17.7616 18.2915 17.2783 18.2915H15.5283Z",
					fill: "#808080"
				})
			]
		})
	})
});
const ForwardRef = forwardRef(SvgPayments);
export default ForwardRef;
